import React from 'react'
import { Helmet } from 'react-helmet-async'
import BackToCaseStudiesHeader from 'src/components/common/BackToCaseStudiesHeader'
import CaseStudyHeader from 'src/components/common/CaseStudyHeader'
import CaseStudySection from 'src/components/common/CaseStudySection'
import ImageBanner from 'src/components/common/ImageBanner'
import OurJourney from 'src/components/common/OurJourney'
import PlatformFeatures from 'src/components/common/PlatformFeatures'
import ResultsSection from 'src/components/common/ResultsSection'
import StatsGrid from 'src/components/common/StatsGrid'
import TechnologyStack from 'src/components/common/TechnologyStack'
import NotFeelingWell from 'src/views/about/NotFeelingWell'
import { CaseStudyTemplate1Data, CaseStudyMetadata } from 'src/constants/caseStudies/types'

interface Props {
  caseStudyData: CaseStudyTemplate1Data;
  metadata: CaseStudyMetadata;
}

const CaseStudyTemplate1 = (props: Props) => {
    const { caseStudyData, metadata } = props;

    if (!caseStudyData || !metadata) {
        return null;
    }

    const {
        pillLabel,
        title,
        description,
        image,
        imageAlt,
        story,
        challenge,
        stats,
        journeySteps,
        resultsMetrics,
        testimonial,
        platformFeatures,
        technologies,
        securityTitle,
        securityDescription,
    } = caseStudyData;

    const {
        meta: {
            title: metaTitle,
            description: metaDescription,
            canonicalUrl,
            ogImage,
        },
    } = metadata;

    return (
        <div className="flex flex-col">
            <Helmet>
                <title>{metaTitle}</title>
                <meta
                    name="description"
                    content={metaDescription}
                />
                <link rel="canonical" href={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:title" content={metaTitle} />
                <meta
                    property="og:description"
                    content={metaDescription}
                />
                <meta property="og:image" content={ogImage} />
            </Helmet>
            <BackToCaseStudiesHeader />


            <div className="container mx-auto px-4 flex-1">
                <CaseStudyHeader
                    pillLabel={pillLabel}
                    title={title}
                    description={description}
                />
                <ImageBanner image={image} alt={imageAlt} />
                <section className="container mx-auto px-4 py-16">
                    <div className="max-w-3xl mx-auto space-y-16">
                        {story && (
                            <CaseStudySection
                                title={story.title}
                                content={story.content}
                            />
                        )}
                        
                        <StatsGrid stats={stats} />

                        {challenge && (
                            <CaseStudySection
                                title={challenge.title}
                                content={challenge.content}
                            />
                        )}
                    </div>
                </section>
            </div>
            
            <OurJourney steps={journeySteps} />
            
            <ResultsSection
                metrics={resultsMetrics}
                testimonial={testimonial}
            />

            <PlatformFeatures
                title="Platform Features"
                features={platformFeatures}
            />

            <TechnologyStack
                title="Technology Stack"
                technologies={technologies}
                securityTitle={securityTitle}
                securityDescription={securityDescription}
                backgroundImage={
                  metadata.slug === 'realtypass-web-app' 
                    ? 'realty-pass/Homepage.png' 
                    : metadata.slug === 'smartcerts'
                    ? 'smart-certs/main.png'
                    : undefined
                }
                imagePosition="right"
                imageLayout={metadata.slug === 'smartcerts' ? 'row' : 'offset'}
            />

            <div className='my-16'>
            <NotFeelingWell />
            </div>
        </div>
    )
}

export default CaseStudyTemplate1

